import { useState, useEffect } from "react";
import HttpApis from "./../services/HttpApis";
import { message } from "antd";

export const useWatchlist = (authtoken, slug) => {
  const [watchList, setWatchList] = useState([]);

  // ✅ Fetch Watchlist
  const fetchWatchList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${authtoken}`,
        "Content-Type": "application/json",
      };
      const response = await HttpApis.getWatchList("", headers);
      const list = response?.data?.data || response?.data || [];
      setWatchList(list);
    } catch (error) {
      console.log("Watchlist fetch error:", error);
      setWatchList([]);
    }
  };

  // ✅ Add to favorites
  const handleAdd = async () => {
    const headers = {
      Authorization: `Bearer ${authtoken}`,
      "Content-Type": "application/json",
    };

    // ✅ Flatten all content arrays for easier slug comparison
    const allItems =
      watchList.flatMap((section) => section.content || []) || [];
    const isAlreadyInFavorites = allItems.some((item) => item.slug === slug);
    if (isAlreadyInFavorites) {
      message.info("Item is already in your favorites");
      return;
    }

    const response = await HttpApis.postAddTofavourite(slug, headers);

    if (response.status === 200) {
      message.success("Item added to favorites");
      fetchWatchList();
    } else {
      message.error("Failed to add item to favorites");
    }
  };

  // ✅ Remove from favorites
  const handleRemove = async () => {
    const headers = {
      Authorization: `Bearer ${authtoken}`,
      "Content-Type": "application/json",
    };

    const response = await HttpApis.postRemovefavourite(slug, headers);

    if (response.status === 200) {
      message.success("Item removed from favorites");
      fetchWatchList();
    } else {
      message.error("Failed to remove item from favorites");
    }
  };

  const allItems = watchList.flatMap((section) => section.content || []);
  const isInWatchList = allItems.some((item) => item.slug === slug);

  useEffect(() => {
    if (authtoken) {
      fetchWatchList();
    }
  }, [authtoken]);

  return { watchList, handleAdd, handleRemove, isInWatchList };
};
